import type { BonesMap } from '../../gltf/types';

function getBonesMapPath(meshPath: string): string {
  return meshPath.replace(/\.(glb|gltf|fbx)$/i, '.json');
}

/**
 * Fetches bones map JSON with credentials (same as GLTF flow).
 */
export async function fetchBonesMapWithCredentials(
  meshPath: string,
): Promise<BonesMap> {
  const bonesMapPath = getBonesMapPath(meshPath);
  try {
    const res = await fetch(bonesMapPath, { credentials: 'include' });
    if (!res.ok) return {};
    const data = await res.json();
    return data.joints ?? {};
  } catch {
    return {};
  }
}
